import {
  CalendarDays,
  ChartNoAxesCombined,
  Database,
  Grid2X2,
  Settings2,
  ShieldCheck,
  Users,
  type LucideIcon,
} from 'lucide-react';
import type { Capability } from '../../types';

export type ModuleKey = 'setup' | 'events' | 'mod' | 'stats' | 'data' | 'team' | 'admin';

export interface ShellModule {
  key: ModuleKey;
  capability: Capability;
  name: string;
  shortName: string;
  icon: LucideIcon;
}

export const shellModules: ShellModule[] = [
  { key: 'setup', capability: 'events', name: 'Zoom Setup', shortName: 'Setup', icon: Settings2 },
  { key: 'events', capability: 'events', name: 'Events', shortName: 'Events', icon: CalendarDays },
  { key: 'mod', capability: 'moderate', name: 'Moderation', shortName: 'Moderation', icon: ShieldCheck },
  { key: 'stats', capability: 'stats', name: 'Stats', shortName: 'Stats', icon: ChartNoAxesCombined },
  { key: 'data', capability: 'data', name: 'Data', shortName: 'Data', icon: Database },
  { key: 'team', capability: 'team', name: 'Team Status', shortName: 'Team', icon: Grid2X2 },
  { key: 'admin', capability: 'admin', name: 'Admin', shortName: 'Admin', icon: Users },
];

export function isModuleKey(value: string): value is ModuleKey {
  return shellModules.some((module) => module.key === value);
}
